import { UntypedFormGroup, UntypedFormControl, Validators, FormControl, FormGroup } from '@angular/forms';

export enum RegisterFields {
  Email = 'Email',
  Password = 'password',
  FirstName = 'FirstName',
  LastName = 'LastName'
}


export interface RegisterForm {
  [RegisterFields.FirstName]: FormControl<string>,
  [RegisterFields.LastName]: FormControl<string>,
  [RegisterFields.Email]: FormControl<string>,
}


export const generateRegisterForm = (): FormGroup<RegisterForm> => {
  return new FormGroup<RegisterForm>({
      [RegisterFields.FirstName]: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      [RegisterFields.LastName]: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      [RegisterFields.Email]: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.email]}),
    //  [RegisterFields.Password]: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
    //  [RegisterFieldsGeneral.AccountType]: new UntypedFormControl('Buyer', [Validators.required]),
     // [RegisterFieldsCategories.Company]: new FormGroup({
    //    [RegisterFieldsCompany.CompanyName]: new FormControl('', [Validators.required]),
    //  }),
  });
  };
